module.exports = __webpack_public_path__ + "static/logo-blue-dix30-dcf5bd09d84233c3257ff68fae0fde6f.png";